module.exports = __webpack_public_path__ + "static/media/lte2.3857f386.jpg";